// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quick-move-groups{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}", ""]);
// Exports
module.exports = exports;
